import IconFlagUsa from 'components/icons/flags/IconFlagUsa';
import IconFlagSpain from 'components/icons/flags/IconFlagSpain';
import IconFlagChina from 'components/icons/flags/IconFlagChina';
import IconFlagPhilippines from 'components/icons/flags/IconFlagPhilippines';
import IconFlagVietnam from 'components/icons/flags/IconFlagVietnam';
import IconFlagSaudiArabia from 'components/icons/flags/IconFlagSaudiArabia';
import IconFlagFrance from 'components/icons/flags/IconFlagFrance';
import IconFlagKorea from 'components/icons/flags/IconFlagKorea';
import IconFlagRussia from 'components/icons/flags/IconFlagRussia';
import IconFlagPortugal from 'components/icons/flags/IconFlagPortugal';
import IconFlagHaiti from 'components/icons/flags/IconFlagHaiti';
import IconFlagIndia from 'components/icons/flags/IconFlagIndia';
import IconFlagGermany from 'components/icons/flags/IconFlagGermany';
import IconFlagPoland from 'components/icons/flags/IconFlagPoland';
import IconFlagItaly from 'components/icons/flags/IconFlagItaly';
import IconFlagPakistan from 'components/icons/flags/IconFlagPakistan';
import IconFlagIran from 'components/icons/flags/IconFlagIran';
import IconFlagJapan from 'components/icons/flags/IconFlagJapan';
import IconFlagBangladesh from 'components/icons/flags/IconFlagBangladesh';
import IconFlagThailand from 'components/icons/flags/IconFlagThailand';

const primaryLanguages = [
  {
    name: 'English',
    code: 'ENG',
    icon: IconFlagUsa,
  },
  {
    name: 'Spanish',
    code: 'SPA',
    icon: IconFlagSpain,
  },
  {
    name: 'Chinese',
    code: 'ZHO',
    icon: IconFlagChina,
  },
  {
    name: 'Tagalog',
    code: 'TGL',
    icon: IconFlagPhilippines,
  },
  {
    name: 'Vietnamese',
    code: 'VIE',
    icon: IconFlagVietnam,
  },
  {
    name: 'Arabic',
    code: 'ARA',
    icon: IconFlagSaudiArabia,
  },
  {
    name: 'French',
    code: 'FRA',
    icon: IconFlagFrance,
  },
  {
    name: 'Korean',
    code: 'KOR',
    icon: IconFlagKorea,
  },
  {
    name: 'Russian',
    code: 'RUS',
    icon: IconFlagRussia,
  },
  {
    name: 'Portuguese',
    code: 'POR',
    icon: IconFlagPortugal,
  },
  {
    name: 'Haitian',
    code: 'HAT',
    icon: IconFlagHaiti,
  },
  {
    name: 'Hindi',
    code: 'HIN',
    icon: IconFlagIndia,
  },
  {
    name: 'German',
    code: 'DEU',
    icon: IconFlagGermany,
  },
  {
    name: 'Polish',
    code: 'POL',
    icon: IconFlagPoland,
  },
  {
    name: 'Italian',
    code: 'ITA',
    icon: IconFlagItaly,
  },
  {
    name: 'Urdu',
    code: 'URD',
    icon: IconFlagPakistan,
  },
  {
    name: 'Persian',
    code: 'FAS',
    icon: IconFlagIran,
  },
  {
    name: 'Telugu',
    code: 'TEL',
    icon: IconFlagIndia,
  },
  {
    name: 'Japanese',
    code: 'JPN',
    icon: IconFlagJapan,
  },
  {
    name: 'Gujarati',
    code: 'GUJ',
    icon: IconFlagIndia,
  },
  {
    name: 'Bengali',
    code: 'BEN',
    icon: IconFlagBangladesh,
  },
  {
    name: 'Tamil',
    code: 'TAM',
    icon: IconFlagIndia,
  },
  {
    name: 'Punjabi',
    code: 'PAN',
    icon: IconFlagIndia,
  },
  {
    name: 'Thai',
    code: 'THA',
    icon: IconFlagThailand,
  },
];

export default primaryLanguages;



// WEBPACK FOOTER //
// ./src/config/primaryLanguages.js